import { apiCall } from "@/common/api/ApiResult.model";
import { get_finding_count } from "@/common/api/findings/findings.api";
import {
  ApplicationType,
  DataSourceType,
} from "@/views/customize/data-sources/data/model";

export const get_all_piis = apiCall<
  {
    pii_ids: string[];
    session_id: number;
    root_folder_id: string;
  },
  any
  // @ts-ignore
>("on-prem.all_pii_labels_count", async ({ session_id, pii_ids }) => {
  const res = await get_finding_count({
    application: "network_file_system" as ApplicationType,
    service: "onprem_fs" as DataSourceType,
    axis_z: {
      type: "Session",
      value: session_id,
    },
    label_ids: pii_ids,
    type: "sensitive_information",
  });
  if (res.success) {
    return res;
  } else {
    return res;
  }
});
